import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { AppRouter } from '@/app/router';
import { Analytics } from '@/shared/analytics/Analytics';

export function App() {
  const { i18n } = useTranslation();

  return (
    <>
      <Helmet>
        <html lang={i18n.language || 'ka'} />
        <title>BEQSAN — ხელით აწყობილი კარფანჯრები ბათუმის ფაბრიკაში</title>
      </Helmet>
      <Analytics />
      <AppRouter />
    </>
  );
}
